"use client";

import { useRef, type ReactNode } from "react";
import { gsap, useGSAP } from "@/lib/gsap-setup";

/** Contenedor que anima entrada al montar (usar `key` distinto en el padre para cada paso). */
export function GsapStepEnter({ children, className }: { children: ReactNode; className?: string }) {
  const root = useRef<HTMLDivElement>(null);
  useGSAP(
    () => {
      const el = root.current;
      if (!el) return;
      gsap.fromTo(el, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.25, ease: "power2.out" });
    },
    { scope: root },
  );
  return (
    <div ref={root} className={className}>
      {children}
    </div>
  );
}

/** Panel que se despliega al pasar `open` a true (altura + opacidad). */
export function GsapCollapsibleSummary({ open, className, children }: { open: boolean; className?: string; children: ReactNode }) {
  const root = useRef<HTMLDivElement>(null);
  useGSAP(
    () => {
      if (!open) return;
      const el = root.current;
      if (!el) return;
      gsap.set(el, { height: 0, opacity: 0 });
      gsap.to(el, { height: "auto", opacity: 1, duration: 0.28, ease: "power3.out" });
    },
    { scope: root, dependencies: [open] },
  );
  if (!open) return null;
  return (
    <div ref={root} className={className} style={{ overflow: "hidden" }}>
      {children}
    </div>
  );
}
